import { sx } from '~/utils';

export default sx(() => ({
  container: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    justifyContent: 'center',
  },

  containerLoading: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },

  label: {
    color: 'inherit',
  },
}));
